import gql from "graphql-tag";

export const GET_ACTIONS = gql`
  query getActions($entityName: String!) {
    getActions(entityName: $entityName) {
      name
    }
  }
`;
